<template>
  <div class="d-flex justify-space-between">
    <v-app-bar color="header" dark style="height: 64px" app clipped-left>
      <v-app-bar-nav-icon @click="openMenu" style="height: 40px" />
      <v-toolbar-title
        @click="goToDashboard"
        style="cursor: pointer; height: 41px"
        class="d-flex"
      >
        <v-img
          src="../../assets/tiempoAsistencia.png"
          alt="user"
          max-width="70"
        />
        <div class="flex-column">
          <p class="title-digicard">{{ $tc("nav.digicard") }}</p>
          <p class="title-ds9">{{ $tc("nav.title") }}</p>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <Menu />
    </v-app-bar>
    <v-navigation-drawer
      app
      color="white"
      temporary
      align-center
      v-model="drawer"
    >
      <div class="d-flex align-center flex-column mb-4 mt-5">
        <h2
          class="font-weight-regular text-capitalize text-center"
          id="text_name_user"
        >
          {{ userName }}
        </h2>
      </div>

      <v-list nav dense style="overflow: hidden" v-model="selectItem">
        <v-list-item-group color="white" v-for="item in items" :key="item.text">
          <v-list-item :to="item.route" color="header" v-if="can(item.code)">
            <v-icon
              class="mr-2"
              style="width: 20px; font-size: 18px"
              :style="{ color: item.color }"
              v-if="can(item.code)"
            >
              {{ item.icon }}
            </v-icon>
            <v-list-item-title class="ml-2">{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>

        <v-list-group
          v-for="group in itemsDefinitionsWithStatus"
          :key="group.key"
          :value="group.isActive"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $tc(`nav.${group.key}`)
              }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <div
            class="scrollable-list"
            :style="{ 'max-height': viewDef() ? '200px' : '500px' }"
          >
            <v-list-item
              v-for="item in group.items"
              :key="item.text"
              :to="item.route"
              color="header"
              v-if="can(item.code)"
              style="padding-left: 40px"
              class="my-0"
            >
              <v-icon
                :style="{ color: item.color }"
                style="width: 20px; font-size: 22px"
                v-if="can(item.code)"
              >
                {{ item.icon }}
              </v-icon>
              <v-list-item-title class="ml-2">{{
                item.text
              }}</v-list-item-title>
            </v-list-item>
          </div>
        </v-list-group>
      </v-list>

      <v-col class="icon-logout pa-0 ma-0 d-flex justify-center">
        <v-container>
          <v-btn
            block
            @click="logout()"
            color="secondary"
            style="color: #718294"
            class="bn"
          >
            <v-icon style="font-size: 18px; color: #718294" class="mr-4"
              >fa-sign-out-alt</v-icon
            >
            {{ $tc("nav.logout") }}
          </v-btn>
        </v-container>
      </v-col>
    </v-navigation-drawer>
  </div>
</template>
<script>
import Menu from "./Menu.vue";
import permissions from "../mixins/permissions";
import insurable from "../../store/common/insurable";
export default {
  components: { Menu },
  mixins: [permissions],
  data() {
    return {
      heigth: null,
      drawer: false,
      selectItem: [],
      items: [
        {
          icon: "fa-home",
          text: this.$tc("nav.dashboard"),
          route: "/Dashboard",
          code: "menu:dashboard",
          color: "#4781c2",
        },
        {
          icon: "fa-clock",
          text: this.$tc("nav.gestionTiempos"),
          route: "/GestionTiempos",
          code: "menu:gestiontiempos",
          color: "#4781c2",
        },
        {
          icon: "fa-user-clock",
          text: this.$tc("nav.gestionEmpleados"),
          route: "/gestionEmpleados",
          code: "menu:gestionempleados",
          color: "#4781c2",
        },
        {
          icon: "fa-network-wired",
          text: this.$tc("nav.workflow"),
          route: "/FlujosTrabajo",
          code: "menu:flujostrabajo",
          color: "#4781c2",
        },
        {
          icon: "mdi-chart-bar",
          text: this.$tc("nav.report"),
          route: "/Reportes",
          code: "menu:reportes",
          color: "#4781c2",
        },
      ],
      itemsDefinitions: {
        general: [
          {
            icon: "mdi-group",
            text: this.$tc("nav.groups"),
            route: "/Grupos",
            code: "menu:grupos",
            color: "#2165B5",
          },
          {
            icon: "mdi-calendar-multiselect",
            text: this.$tc("nav.holidayGroups"),
            route: "/GruposFeriados",
            code: "menu:grupoferiados",
            color: "#2165B5",
          },
          {
            icon: "mdi-card-account-details",
            text: this.$tc("nav.cards"),
            route: "/Tarjetas",
            code: "menu:tarjetas",
            color: "#2165B5",
          },
          {
            icon: "mdi-account-hard-hat",
            text: this.$tc("nav.operators"),
            route: "/Operadores",
            code: "menu:operadores",
            color: "#2165B5",
          },
          {
            icon: "mdi-account-lock",
            text: this.$tc("nav.auto"),
            route: "/Autorizaciones",
            code: "menu:autorizaciones",
            color: "#2165B5",
          },
          {
            icon: "fa-layer-group",
            text: this.$tc("nav.businessUnits"),
            route: "/UnidadesNegocios",
            code: "menu:unnegocios",
            color: "#2165B5",
          },
          {
            icon: "fas fa-list",
            text: this.$tc("nav.attributes"),
            route: "/Atributos",
            code: "menu:atributos",
            color: "#2165B5",
          },
          {
            icon: "fas fa-tags",
            text: this.$tc("nav.labels"),
            route: "/Etiquetas",
            code: "menu:etiquetas",
            color: "#2165B5",
          },
        ],
        timeAssist: [
          {
            icon: "mdi-account-wrench",
            text: this.$tc("nav.concepts"),
            route: "/Conceptos",
            code: "menu:conceptos",
            color: "#6fabc2",
          },
          {
            icon: "fa-solid fa-file-invoice-dollar",
            text: this.$tc("nav.salariesConcepts"),
            route: "/ConceptosSueldos",
            code: "menu:csueldos",
            color: "#6fabc2",
          },
          {
            icon: "mdi-folder-home",
            text: this.$tc("nav.costCenters"),
            route: "/CentrosCosto",
            code: "menu:centroscosto",
            color: "#6fabc2",
          },
          {
            icon: "far fa-clock",
            text: this.$tc("nav.schedule"),
            route: "/Horarios",
            code: "menu:horarios",
            color: "#6fabc2",
          },
          {
            icon: "mdi-folder-table",
            text: this.$tc("nav.modelsLiquidations"),
            route: "/Modelos",
            code: "menu:modelos",
            color: "#6fabc2",
          },
          {
            icon: "fas fa-comment-dots",
            text: this.$tc("nav.comments"),
            route: "/Comentarios",
            code: "menu:comentarios",
            color: "#6fabc2",
          },
          {
            icon: "mdi-calendar-month",
            text: this.$tc("nav.liquidations"),
            route: "/Liquidaciones",
            code: "menu:liquidaciones",
            color: "#6fabc2",
          },
          {
            icon: "mdi-monitor",
            text: this.$tc("nav.monitor"),
            route: "/MonitorCA3",
            code: "menu:monitorca3",
            color: "#6fabc2",
          },
          {
            icon: "mdi-account-arrow-up",
            text: this.$tc("nav.licenseUpload"),
            route: "/CargaDeLicencias",
            code: "menu:cargalicencias",
            color: "#6fabc2",
          },
          {
            icon: "mdi-account-details",
            text: this.$tc("nav.currentAccounts"),
            route: "/CuentasCorrientes",
            code: "menu:cuentascorrientes",
            color: "#6fabc2",
          },
        ],
        accessControl: [
          {
            icon: "mdi-account-cog",
            text: this.$tc("nav.accessPermissions"),
            route: "/PermisosDeAcceso",
            code: "menu:permisos",
            color: "#00426b",
          },
          {
            icon: "fas fa-tasks",
            text: this.$tc("nav.pcas"),
            route: "/Pcas",
            code: "menu:pcasroles",
            color: "#00426b",
          },
        ],
      },
      userName: localStorage.getItem("name"),
    };
  },
  mounted() {
    this.heigth = innerHeight;
  },
  computed: {
    insurable() {
      return insurable.state.insurable;
    },
    currentRoute() {
      return this.$route.path;
    },
    itemsDefinitionsWithStatus() {
      return Object.keys(this.itemsDefinitions).map((key) => {
        const isActive = this.itemsDefinitions[key].some(
          (item) => item.route === this.currentRoute
        );
        return {
          key,
          items: this.itemsDefinitions[key],
          isActive,
        };
      });
    },
  },
  methods: {
    viewDef() {
      if (this.heigth > 700) {
        return false;
      } else {
        return true;
      }
    },
    logout() {
      localStorage.removeItem("empId");
      localStorage.removeItem("auditRegis");
      localStorage.removeItem("token");
      localStorage.removeItem("operId");
      localStorage.removeItem("rolId");
      localStorage.removeItem("name");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("asegurables");
      localStorage.removeItem("init");
      localStorage.removeItem("active2fa");
      this.$router.push({ path: "/signin" });
    },
    goToDashboard() {
      this.$router.push({ path: "/Dashboard" });
    },
    openMenu() {
      this.drawer = !this.drawer;
      this.validateInsurable();
    },
    validateInsurable() {
      const asegurables = JSON.parse(localStorage.getItem("asegurables"));
      const filteredItemsDefinitions = {};

      Object.keys(this.itemsDefinitions).forEach((key) => {
        const category = this.itemsDefinitions[key];
        filteredItemsDefinitions[key] = category.filter((item) =>
          asegurables?.includes(item.code)
        );
      });

      this.itemsDefinitions = filteredItemsDefinitions;
    },
  },
};
</script>

<style>
.bn {
  text-transform: capitalize !important;
  font-weight: lighter !important;
}

.bn:hover {
  background-color: #a0caff;
  color: #0365cf !important;
  font-weight: bold;
}

.icon-logout {
  position: absolute;
  bottom: 0;
}

.icon-logout:hover {
  color: #0365cf !important;
}

.v-toolbar__content {
  margin-right: 14px;
}

.v-list-group__header {
  padding-left: 2px !important;
  margin-left: 8px !important;
}

.v-list-item__icon {
  margin-right: 9px !important;
}

.title-digicard {
  font-size: 15px;
  margin-bottom: -7px !important;
  color: #ffffff;
}

.title-ds9 {
  font-size: 17px;
  font-weight: bold;
  margin-left: 20px;
  color: #ffffff;
}
.scrollable-list {
  overflow: auto !important;
  scrollbar-width: initial;
  margin-top: -10px !important;
}
#text_name_user {
  width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 20px;
}
</style>
